import React from "react";
// css
import "./GetInspire.css";
// assets
import giImg1 from "assets/Images/giCard/gi-card-img1.png";
import giImg2 from "assets/Images/giCard/gi-card-img2.png";
import giImg3 from "assets/Images/giCard/gi-card-img3.png";
// component
import GetInspireCard from "Utills/GetInspireComponents/GetInspireCard/GetInspireCard";

// Get inspire home component
const GetInspire = () => {
  // data
  const getInspireData = [
    {
      title: "How to pick your best choice with ideal price for your needs",
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In odio vitae gravida iaculis metus. Pharetra nibh mattis eget massa vel.",
      img: giImg1,
    },
    {
      title: "Schedule your lovely vacation by choosing precise date",
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In odio vitae gravida iaculis metus. Pharetra nibh mattis eget massa vel.",
      img: giImg2,
    },
    {
      title: "Are you on hurry? get a book intraday with multiple options",
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In odio vitae gravida iaculis metus. Pharetra nibh mattis eget massa vel.",
      img: giImg3,
    },
  ];
  return (
    <>
      <section className="get_inspire" id="offers">
        <div className="get_inspire_container">
          <h1>Get inspiration for your next trip</h1>
          <div className="row gy-5">
            {getInspireData.map((d, i) => {
              return (
                <div key={i} className="col-12 col-sm-12 col-md-4 col-lg-4">
                  <GetInspireCard title={d.title} text={d.text} img={d.img} />
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default GetInspire;
